import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PetForm from '../components/Pet/PetForm';

const PetFormPage = () => {
  const { id } = useParams();
  const location = useLocation();
  
  // ✅ 判斷是否為新增模式：路徑是 /pet/add 或沒有 id
  const isAddMode = location.pathname.includes('/pet/add') || !id;
  
  // ✅ 只有在編輯模式（有 id 且不是 add 路徑）時才傳遞 petId
  const isEdit = !isAddMode && Boolean(id);

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-primary-50/30 pt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <PetForm petId={isEdit ? id : null} isEdit={isEdit} />
      </div>
    </div>
  );
};

export default PetFormPage;